import { effect, inject, Injectable, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';

@Injectable({
  providedIn: 'root',
})
export class I18nTitleStrategyService extends TitleStrategy {
  private readonly title: Title = inject(Title);
  private readonly translateService: TranslocoService =
    inject(TranslocoService);

  private readonly titleResource = signal<string>('');

  constructor() {
    super();

    effect(() => {
      const titleKey = this.titleResource();
      if (titleKey) {
        const translatedTitle = this.translateService.translate(titleKey);
        if (translatedTitle) {
          this.title.setTitle(translatedTitle);
        }
      }
    });
  }

  override updateTitle(routerStateSnapshot: RouterStateSnapshot): void {
    let title = this.buildTitle(routerStateSnapshot);
    title ??= _('i18n.TitleStrategy.Default');

    this.titleResource.set(title);
  }
}
